<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
                <div class="row no-gutters">
                    <br />
                </div>
              <div v-if="JobObject.companyProfileId && JobObject.recruiterAccountStatus=='ACCEPT'">
                <div class="d-flex ml-3 mr-3" @click="moveToListOfJobs" v-if="isEditJobPage">
                  <img src="../assets/Back.svg" class="pointer" alt="back"/>
                  <label class="ml-2 mt-1 fontsize16 proximanova stylebold pointer">Edit Details</label>
                  <span class="fontsize10 borderadius12 backgroundcolor7 red borderred mt-lg-2 mt-1 ml-3 stylebold">You cannot edit Job Title once you posted the job</span>
                </div>
                <!-- top navbar -->
                <nav class="nav ml-3 mr-3">
                    <div class="col-12 card-header mt-3 mt-lg-4 mb-3 pl-3 pr-3">
                    <ul class="col-12 pl-0 d-flex  flex-nowrap justify-content-around nav nav-tabs  text-center">
                        <li class="pr-0 pl-0 nav-item navitem1">
                          <div class="d-flex">
                            <div class="my-auto mr-2 pointer">
                              <img src="../assets/BasicInfo2.svg" class="img-fluid" v-if="activeElement==='basicInfo'" alt="basicinfo">
                              <span v-else>
                                <img src="../assets/BasicInfo3.svg" class="img-fluid" v-if="JobObject.isBasicInfoCompleted" alt="basicinfo">
                                <img src="../assets/BasicInfo1.svg" class="img-fluid" v-else alt="basicinfo">
                              </span>
                            </div>
                            <div class="text-left pointer" @click="toggleActiveClass('basicInfo')">
                                <span class="fontsize10 black30 stylebold proximanova" :class="{'black' :JobObject.isBasicInfoCompleted}">Step 1/3</span> <br>
                                <span class="fontsize16 black30 stylebold proximanova text-nowrap" :class="{ 'list-text-color' :activeElement==='basicInfo', 'black' :JobObject.isBasicInfoCompleted}">Basic Info</span>
                            </div>
                          </div>
                        </li>
                        <div class="mt-2 ml-2 mr-2"><img src="../assets/Divider.svg" class="img-fluid " alt="divider"></div>
                        <li class="pr-0 pl-0 nav-item pointer">
                          <div class="d-flex">
                            <div class="my-auto mr-2 pointer">
                              <img src="../assets/JobDetails2.svg" class="img-fluid" v-if="activeElement==='jobDetails'" alt="jobdetails">
                              <span v-else>
                                <img src="../assets/JobDetails3.svg" class="img-fluid" v-if="JobObject.isJobDetailsCompleted" alt="jobdetails">
                                <img src="../assets/JobDetails1.svg" class="img-fluid" v-else alt="jobdetails">
                              </span>
                            </div>
                            <div class="text-left" @click="toggleActiveClass('jobDetails')">
                                <span class="fontsize10 black30 stylebold proximanova" :class="{'black' :JobObject.isJobDetailsCompleted}">Step 2/3</span><br>
                                <span class="fontsize16 black30 stylebold proximanova text-nowrap" :class="{ 'list-text-color' :activeElement==='jobDetails', 'black' :JobObject.isJobDetailsCompleted}">Job Details</span>
                            </div>
                          </div>
                        </li> 
                        <div class="mt-2 ml-2 mr-2"><img src="../assets/Divider.svg" class="img-fluid " alt="divider"></div>
                        <li class="pr-0 pl-0 nav-item pointer">
                          <div class="d-flex">
                            <div class="my-auto mr-2 pointer">
                              <img src="../assets/MoreDetails2.svg" class="img-fluid" v-if="activeElement==='moreDetails'" alt="moredetails">
                              <span v-else>
                                <img src="../assets/MoreDetails3.svg" class="img-fluid" v-if="JobObject.isMoreDetailsCompleted" alt="moredetails">
                                <img src="../assets/MoreDetails1.svg" class="img-fluid" v-else alt="moredetails">
                              </span>
                            </div>
                            <div class="text-left" @click="toggleActiveClass('moreDetails')">
                                <span class="fontsize10 black30 stylebold proximanova" :class="{'black' :JobObject.isMoreDetailsCompleted}">Step 3/3</span><br>
                                <span class="fontsize16 black30 stylebold proximanova text-nowrap" :class="{ 'list-text-color' :activeElement==='moreDetails', 'black' :JobObject.isMoreDetailsCompleted}">More Details</span>
                            </div>
                          </div>
                        </li>                       
                    </ul>
                    </div>
                </nav>
                <div v-if="basicInfoSection">
                  <basic-info :JobObject="JobObject"></basic-info>
                </div>
                <div v-if="jobDetailsSection">
                  <job-details :JobObject="JobObject"></job-details>
                </div>
                <div v-if="moreDetailsSection">
                    <more-details :JobObject="JobObject"></more-details>
                </div>
              </div>
              <div v-else>
                <no-jobs-available></no-jobs-available>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import basicInfo from './postJob/BasicInfo.vue'
import jobDetails from './postJob/JobDetails.vue'
import moreDetails from './postJob/MoreDetails.vue'
import httpbusiness from "@/js/http-business.js"
import httppost from "@/js/http-postjob.js"
import router from '../router.js'
import { bus } from "@/main.js";
import sessionUtils from "@/js/session-util.js";
import noJobsAvailable from '../components/NoJobsAvailable.vue'
Vue.use(Popover);
export default{
    components:{
      basicInfo,
      jobDetails,
      moreDetails,
      noJobsAvailable
    },
    data(){
        return{
            pageloader: true,
            activeElement :'basicInfo',
            isEditJobPage : false,
            basicInfoSection : true,
            jobDetailsSection : false,
            moreDetailsSection : false,
            JobObject : {
              jobId : null,
              companyProfileId : null,
              employeeId : null,
              isEditJobPage : false,
              isBasicInfoCompleted : false,
              isJobDetailsCompleted : false,
              isMoreDetailsCompleted : false,
              selectedCompany : '',
              jobTitle : '',
              titleId : null,
              selectedEmploymentType : '',
              selecetdSeniority : '',
              selectedPayScaleFrom : '',
              selectedPayScaleTo : '',
              country : null,
              state : null,
              city : null,
              selectedMultiselectLocCountry : null,
              selectedMultiselectLocState : null,
              selectedMultiselectLocCity : null,
              pinCode : null,
              companyBenefitsList : [],
              // jobDetjobTitle : '',
              jobDescription : '',
              addedSkillsList : [],
              communicationType : 'email',
              emailId : '',
              creationUserI : null,
              updatedUserI : null,
              jobStatus : null,
              screeningQuestionsList : [],
              module : '',
              jobPostedBy : null,
              recruiterAccountStatus : 'ACCEPT'
            },
        }
    },
    created (){
        //pause the experience video if another culture video is playing
        bus.$on('moveToNext', (data) => {
            this.toggleActiveClass(data)
        })
    },
    methods:{
        toggleActiveClass : function(elementId){
            if(elementId === 'basicInfo'){
              this.activeElement = elementId
              this.basicInfoSection = true;
              this.jobDetailsSection = false
              this.moreDetailsSection = false
            }else if(elementId === 'jobDetails' && this.JobObject.isBasicInfoCompleted){
              this.activeElement = elementId
              this.basicInfoSection = false;
              this.jobDetailsSection = true
              this.moreDetailsSection = false
            }else if(elementId === 'moreDetails' && this.JobObject.isBasicInfoCompleted && this.JobObject.isJobDetailsCompleted){
              this.activeElement = elementId
              this.basicInfoSection = false;
              this.jobDetailsSection = false
              this.moreDetailsSection = true
            }
        },
        getJobDetails(){
          httppost.get('/postjob/getJobDataById?jobId='+this.JobObject.jobId)
          .then((response) => {
            this.pageloader = false;
            console.log(response)
            let jobobj = response.data
            this.JobObject.jobTitle = jobobj.jobTitle;
            this.JobObject.titleId = jobobj.titleId;
            this.JobObject.selectedEmploymentType = jobobj.employmentTypeId;
            this.JobObject.selecetdSeniority = jobobj.seniorityId;
            this.JobObject.selectedPayScaleFrom = jobobj.payScaleFrom;
            this.JobObject.selectedPayScaleTo = jobobj.payScaleTo;
            this.JobObject.country = response.data.countryId;
            this.JobObject.state = response.data.stateId;
            this.JobObject.city = response.data.cityId;
            this.JobObject.selectedMultiselectLocCountry = response.data.country;
            this.JobObject.selectedMultiselectLocState = response.data.state;
            this.JobObject.selectedMultiselectLocCity = response.data.city;
            this.JobObject.pinCode = response.data.zipcode;
            this.JobObject.companyBenefitsList = response.data.companyBenefitsList;
            this.JobObject.jobDescription = response.data.jobDesc;
            this.JobObject.addedSkillsList = response.data.addedSkillsList;
            this.JobObject.communicationType = response.data.communicationType;
            this.JobObject.emailId = response.data.emailId;
            this.JobObject.jobStatus = response.data.jobStatus;
            this.JobObject.screeningQuestionsList = response.data.screeningQuestionsList;
            this.JobObject.selectedCountry = response.data.country;
            this.JobObject.selectedState = response.data.state;
            this.JobObject.selectedCity = response.data.city;
          }).catch((e) => {
            console.log(e.response)
            this.pageloader = false;
          })
        },
        moveToListOfJobs(){
          router.push({
            name : 'postedJobs'
          })
        }
    },
    mounted() {
      window.scrollTo(0, 0)
      let currentRoute = this.$route.name;
      this.JobObject.companyProfileId = sessionUtils.getCompanyProfileId();
      this.JobObject.selectedCompany = sessionUtils.getRecruiterCompanyName();
      this.JobObject.employeeId = sessionUtils.getBusinessAccountId();
      this.JobObject.jobId = sessionUtils.getSelectedJobId()
      this.JobObject.emailId = sessionUtils.getCompanyEmail();
      this.JobObject.creationUserI = sessionUtils.getCompanyEmail();
      this.JobObject.updatedUserI = sessionUtils.getCompanyEmail();
      this.JobObject.module = sessionUtils.getmodule();
      if(this.JobObject.module == 'Recruiter'){
        this.JobObject.companyProfileId = sessionUtils.getRecruiterCompanyprofileId();
        this.JobObject.employeeId = sessionUtils.getRecruiterCompanyBusinessaccountId();
        this.JobObject.jobPostedBy = sessionUtils.getCompanyProfileId();
        this.JobObject.recruiterAccountStatus = sessionUtils.getRecruiterAccountStatus()
      }
      console.log("job object : ", this.JobObject)
      if(currentRoute === 'postajob'){
        this.isEditJobPage = false;
        this.pageloader = false;
        this.JobObject.jobId = null;
      }
      if(currentRoute === 'editjob'){
        this.sidemenuHeaderText = 'Edit Company Account'
        this.isEditJobPage = true;
        this.JobObject.isEditJobPage = true;
        this.JobObject.isBasicInfoCompleted = true;
        this.getJobDetails()
      }
    }
}
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
@import '../css/vue2-datepicker.css';
.nav-link {
  padding: 0px 0px 0px 0px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 0px 0px 3px 0px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.borderred{
  height: 23px;
  padding: 2px 5px 2px 5px;
}
.card-header{
  overflow-x: auto;
}
.img-fluid{
  max-width: none;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.edit {
  cursor: pointer;
  border: 1px solid rgba(31, 31, 31, .1);
  border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.list-text-color {
  color: #0078FF !important;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.nameblock {
  padding-left: 0 !important;
}
/* form styles */
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  /* border-bottom: 1px solid #757575; */
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
	position: relative;
	z-index : 1;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
}
@media only screen and (max-width: 530px) {
  .navitem1{
    padding-left: 90px !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
